import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ObsAddActionComponent } from '../../bog_tour/obs-add-action/obs-add-action.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { AssignedToModalPage } from 'src/app/pages/assigned-to-modal/assigned-to-modal.page';

import { BaseInjectorService } from 'src/app/base/base-service.injector';
import { AppService } from 'src/app/app.service';
import * as _ from 'lodash';
import { ActionService } from 'src/app/services/action/action.service';
import { TreasurehuntService } from 'src/app/services/treasureHunt/treasurehunt.service';
import { where } from '@angular/fire/firestore';
import { AddUserForActionPage } from './add-user-for-action/add-user-for-action.page';
import { element } from 'protractor';

@Component({
  selector: 'app-th-add-action-for-finding',
  templateUrl: './th-add-action-for-finding.component.html',
  styleUrls: ['./th-add-action-for-finding.component.scss'],
  standalone: false,
})
export class ThAddActionForFindingComponent extends BaseInjectorService implements OnInit {
  constructor(
    private treasurehuntService : TreasurehuntService,
    private appService: AppService,private actionService:ActionService) {
    super();
  }
  form: FormGroup;
  minDate = new Date();
  selected_user: any;
  areaOwnerData: any = {};
  siteManagerData : any = {};
  selectedUserData : any;
  @ViewChild('picker') picker!: MatDatepicker<Date>;
  assigned_to_person_unique_id: string = "";
  priority: any = [
    { label: 'ACTION.LBL_URGENT', value: 'Urgent' },
    { label: 'HAZ.PRIORITY_HIGH', value: 'High' },
    { label: 'HAZ.PRIORITY_MEDIUM', value: 'Medium' },
    { label: 'HAZ.PRIORITY_LOW', value: 'Low' },
  ]

  ngOnInit() {
    this.form = new FormGroup({
      dueDateTime: new FormControl<Date | null>(null, Validators.required),
      assignedTo: new FormControl(this.selected_user || '', Validators.required),
      actionSummary: new FormControl('', Validators.required),
      priority: new FormControl('', Validators.required)
    });
  }
 ionViewDidEnter() {
  this.loadSiteOwnerData();
 }

 async loadSiteOwnerData(){
   let siteOwnerData: any = {};
    let siteOwnerEmail = siteOwnerData.email;
    if (siteOwnerEmail) {
      if(this.findUserDetails(siteOwnerEmail)){
        this.form.get('assignedTo')?.setValue(siteOwnerEmail);
        this.areaOwnerData = siteOwnerData;
      }
    }
   let siteManagerInfo: any = {};
   siteManagerInfo = await this.getAreaManagerData(this.treasurehuntService?.TreasureHuntinfo?.currentObservationInfo);
    if (siteManagerInfo?.email) {
      if(this.findUserDetails(siteManagerInfo?.email)){
        this.siteManagerData = siteManagerInfo;
    }
    }
  
 }




 findUserDetails(email: any){
    let userDetails = this.appService.appData.usersByCountry.find((element: any) => {
        return  element.email == email;
    })
    if(userDetails){
       this.assigned_to_person_unique_id = userDetails.person_unique_id;
    }
    return userDetails;
 }


  openPicker() {
    this.picker.open();
  }

  submit() {
     const rawDue = this.form.value.dueDateTime;
    if (this.form.invalid || !rawDue) {
      return;
    }

    let due: Date;
    if (rawDue instanceof Date) {
      due = rawDue;
    } else if ((rawDue as any).toDate && typeof (rawDue as any).toDate === 'function') {
      due = (rawDue as any).toDate();
    } else {
      due = new Date(rawDue as any);
    }

    const y = due.getFullYear();
    const m = String(due.getMonth() + 1).padStart(2, '0');
    const d = String(due.getDate()).padStart(2, '0');
    const isoLike = `${y}-${m}-${d}`;

    console.log('due date (Date):', due);
    console.log('due date (YYYY-MM-DD):', isoLike);
    console.log('action title:', this.form.value.assignedTo);
    console.log('action description:', this.form.value.actionSummary);
    console.log('priority:', this.form.value.priority);
    this.addAction();
  }
  onChange(value: any) {
    this.form.get('priority')?.setValue(value);
    this.form.get('priority')?.markAsTouched();
    console.log(value);
  }


  async openUsersModal() {
    console.log("-----,this.areaOwnerData",this.areaOwnerData);
    const modal = await this.modalController.create({
      component: AddUserForActionPage,
      cssClass: 'th-add-user-for-action-component',
      backdropDismiss: true,
      componentProps: {
        usersList: this.appService.appData.usersByCountry,
        mode: "treasure-add-action",
        fromPage: "add_finding",
        siteManagerInfo : this.siteManagerData,
        siteOwnerInfo : this.areaOwnerData
      },
      animated: true
    });

    await modal.present();

    const selectedUser = await modal.onWillDismiss();


    if (selectedUser?.data?.selectedUser) {
      this.selected_user = selectedUser?.data?.selectedUser.email;
      console.log("selected user", this.selected_user);
      this.form.get('assignedTo')?.setValue(this.selected_user);
      this.form.get('assignedTo')?.markAsDirty();
      this.assigned_to_person_unique_id = selectedUser?.data?.selectedUser.person_unique_id;

      this.selectedUserData = selectedUser?.data?.selectedUser.selected_user || selectedUser?.data?.selectedUser;


      if (selectedUser?.data?.selectedUser.person_unique_id == undefined || selectedUser?.data?.selectedUser.person_unique_id == '') {
        const icareDataRef: any = await this.lhFire.getDocument("icare_person_master", selectedUser.data.selectedUser.email);
        if (icareDataRef.data()) {
          this.assigned_to_person_unique_id = icareDataRef.data().unique_id;
          selectedUser.data.selectedUser.person_unique_id = icareDataRef.data().unique_id;
        }
      }
      //Store in localstorage
      let lastFiveAssignedToUserList = await this.lhStorage.get('lastFiveAssignedToUsers');
      let userArray = lastFiveAssignedToUserList ? lastFiveAssignedToUserList : [];
      const checkIfExists = _.filter(userArray, (u: any) => {
        return u.email === selectedUser.data.selectedUser.email;
      });
      if (userArray.length == 5) {
        if (checkIfExists.length == 0) {
          userArray.splice(0, 1);
        }
      }
      if (checkIfExists.length == 0) {
        let obj = {
          email: selectedUser?.data?.selectedUser.email,
          person_unique_id: selectedUser?.data?.selectedUser.person_unique_id
          , Fname: selectedUser?.data?.selectedUser?.selected_user?.Fname || selectedUser?.data?.selectedUser?.selected_user?.first_name,
          Lname: selectedUser?.data?.selectedUser?.selected_user?.Lname  || selectedUser?.data?.selectedUser?.selected_user?.last_name,
          person_id: selectedUser?.data?.selectedUser?.selected_user?.person_id,
          unique_id: selectedUser?.data?.selectedUser?.selected_user?.unique_id
        }
        userArray.push(obj);
      }
      let finaluserArray = _.uniqBy(userArray, 'email');
      await this.lhStorage.set('lastFiveAssignedToUsers', finaluserArray);

    }
  }

  closeModal(returndata: any = true) {
    this.form.get('assignedTo')?.setValue("");
    this.form.reset();
    this.modalController.dismiss(returndata);
  }

  async addAction() {

    const rawDue = this.form.value.dueDateTime;
    let dueDate: Date | null = null;
    if (rawDue) {
      if (rawDue instanceof Date) {
        dueDate = rawDue;
      } else if ((rawDue as any).toDate && typeof (rawDue as any).toDate === 'function') {
        dueDate = (rawDue as any).toDate();
      } else {
        dueDate = new Date(rawDue as any);
      }
    }

    let actionData: any = {
      dueDateTime: dueDate,
      assignedTo: this.form.value.assignedTo,
      actionSummary: this.form.value.actionSummary,
      priority: this.form.value.priority
    };
    await this.overlayService.presentLoading(this.createLoaderOptions(this.translate.instant('APP_LOADING_LABEL')));
    console.log("this.assigned_to_person_unique_id",this.assigned_to_person_unique_id);
    let actionObject = await this.actionService.getActionObject(this.assigned_to_person_unique_id, "take-bog-tour", "add_finding", "", actionData, "only-action");
   
    this.overlayService.dismissLoading();
    this.closeModal({ result: 'save', actionObject: actionObject , actionData: actionData});
  }

   async getAreaManagerData(currentObservationInfo) {
      try {
        if (!currentObservationInfo?.location_unique_id) {
          return {};
        }

        let dwkWorkGroup_ManagerId: any = '';
        let siteManager: any = {};

        const groupMangerIdData = await this.lhFire.queryCollection(
          'icare_location_master',
          where('unique_id', '==', currentObservationInfo.location_unique_id)
        );

        groupMangerIdData?.docs?.forEach((doc: any) => {
          const data = doc?.data?.();
          if (data?.dwk_work_group_manager) {
            dwkWorkGroup_ManagerId = data.dwk_work_group_manager;
          }
        });

        if (!dwkWorkGroup_ManagerId) {
          return {};
        }

        const groupManagerDetails = await this.lhFire.queryCollection(
          'icare_person_master',
          where('person_id', '==', dwkWorkGroup_ManagerId)
        );

        groupManagerDetails?.docs?.forEach((doc: any) => {
          const data = doc?.data?.();
          if (data) {
            siteManager = { ...data };
          }
        });

        console.log('siteManager---',dwkWorkGroup_ManagerId, siteManager);
        if (siteManager && !siteManager.email && siteManager.id) {
          siteManager.email = siteManager.id;
        }
        if (siteManager && siteManager.unique_id && !siteManager.person_unique_id) {
          siteManager.person_unique_id = siteManager.unique_id;
        }

        return siteManager || {};
      } catch (err) {
        this.logger.error('getAreaManagerData error', err);
        return {};
      }
}

}
